module.exports = __webpack_public_path__ + "fonts/dcd156a.ttf";